import { PiniaColadaQueryHooksPlugin } from "@pinia/colada";
import ToastEventBus from "primevue/toasteventbus";
import i18n from "@/configs/i18n";
import { ToastTimeoutMS } from "@/utils/constants";

const getErrorMessage = (error) => {
  if (!error) return i18n.global.t("error");
  if (typeof error === "string") return error;
  if (error instanceof Error) return error.message || i18n.global.t("error");
  if (typeof error === "object" && "message" in error) {
    return String(error.message || i18n.global.t("error"));
  }
  return i18n.global.t("error");
};

const showErrorToast = (error) => {
  ToastEventBus.emit("add", {
    severity: "error",
    summary: i18n.global.t("error"),
    detail: getErrorMessage(error),
    life: ToastTimeoutMS,
  });
};

export const piniaColadaOptions = {
  plugins: [
    PiniaColadaQueryHooksPlugin({
      onError(error) {
        showErrorToast(error);
      },
    }),
  ],
  queryOptions: {
    staleTime: 5_000,
    gcTime: 5 * 60_000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    ssrCatchError: false,
  },
  mutationOptions: {
    gcTime: 5 * 60_000,
    onError(error) {
      showErrorToast(error);
    },
  },
};
